<template>
  <div class="page_finCost">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
      <div class="top-right">
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName == '1' ? '自动采集设置' : '自动刷新利润表设置'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="财务数据源列表" name="0"></el-tab-pane>
          <el-tab-pane label="自动采集设置" name="1"></el-tab-pane>
          <el-tab-pane label="自动刷新利润表设置" name="2"></el-tab-pane>
        </el-tabs>

        <div>
          <el-form :model="setForm" ref="setForm" label-width="190px">
            <el-form-item :label="activeName=='1' ? '自动采集系统数据' : '自动刷新利润表'" size="small">
              <el-radio-group v-model="setForm.isStart">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动刷新允许操作时间范围" size="small">
              <div class="flex">
                <el-select v-model="setForm.startMonth" size="small" clearable style="width:100px;margin-right:10px" placeholder="">
                  <el-option value="本月"></el-option>
                  <el-option value="下月"></el-option>
                </el-select>
                <el-select v-model="setForm.startDay" size="small" clearable filterable style="width:100px;margin-right:10px" placeholder="">
                  <el-option v-for="(item, index) in 31" :key="index" :value="item" :label="item + '日'"></el-option>
                </el-select>
                <div> ~ </div>
                <el-select v-model="setForm.endMonth" size="small" clearable style="width:100px;margin:0 10px" placeholder="">
                  <el-option value="本月"></el-option>
                  <el-option value="下月"></el-option>
                </el-select>
                <el-select v-model="setForm.endDay" size="small" clearable filterable style="width:100px;margin-right:20px" placeholder="">
                  <el-option v-for="(item, index) in 31" :key="index" :value="item" :label="item + '日'"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="采集时间" size="small">
              <div class="flex">
                <el-select v-model="setForm.type" size="small" clearable style="width:140px;margin-right:10px" placeholder="选择日" @change="changeType">
                  <el-option label="每天" :value="1"></el-option>
                  <el-option label="每周" :value="2"></el-option>
                  <el-option label="每月" :value="3"></el-option>
                  <el-option label="每月最后一天" :value="4"></el-option>
                </el-select>
                <el-select v-model="setForm.day" size="small" clearable filterable style="width:100px;margin-right:20px" placeholder="" v-if="setForm.type==3">
                  <el-option v-for="(item, index) in 31" :key="index" :value="item" :label="item + '日'"></el-option>
                </el-select>
                <el-select v-model="setForm.day" size="small" clearable filterable style="width:100px;margin-right:10px" placeholder="" v-if="setForm.type==2">
                  <el-option label="周一" :value="1"></el-option>
                  <el-option label="周二" :value="2"></el-option>
                  <el-option label="周三" :value="3"></el-option>
                  <el-option label="周四" :value="4"></el-option>
                  <el-option label="周五" :value="5"></el-option>
                  <el-option label="周六" :value="6"></el-option>
                  <el-option label="周日" :value="7"></el-option>
                </el-select>
                <el-time-picker v-model="time" placeholder="" value-format="HH:mm:ss">
                </el-time-picker>
              </div>
            </el-form-item>
            <!-- <div class="record">张三 2024/1/24 09:02:01 设置： 每月1日20:00:00</div> -->
            <el-form-item>
              <el-button type="success" v-preventReClick @click="onSubmit" size="small" style="margin-left:15px" :loading="isBtnLoading">保存</el-button>
            </el-form-item>
          </el-form>

          <div>
            <div class="calTitle"><span class="titleLine">|</span> {{activeName=='1' ? '采集记录' : '刷新记录'}}</div>
            <div class="calList">
              <div class="calItem" v-for="(item,index) in calList" :key="index">
                {{ item.createTime.replace('T',' ') }} 生成 {{ item.busiId }} {{ item.msg }} {{ item.msg1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    number,
    row
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        activeName: '1',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        setForm: {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          type: 1, //1每天，2每周，3每月，4每月最后一日
          day: "",
          hour: "",
          minute: "",
          second: "",
          isStart: "", //1为起动，2为否
          startMonth: "",
          startDay: "",
          endMonth: "",
          endDay: "",
        },
        time: '',
        calList: [], //计算记录列表
        isBtnLoading: false,
        handelMonth: '',
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
      }
      this.getSet();
    },
    methods: {
      checkPermission,
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/financialSource'
          })
        } else {
          this.getSet()
        }
      },
      onSubmit() {
        if (this.setForm.type != 1 && (!this.time || !this.setForm.day)) {
          this.$message.warning('请选择自动计算时间')
        } else {
          let arr = this.time.split(':');
          this.setForm.hour = arr[0];
          this.setForm.minute = arr[1];
          this.setForm.second = arr[2];
          this.isBtnLoading = true;
          let pagename = this.activeName == '1' ? 'FinancialDataSourcesSettings' : 'RefreshProfitSettings';
          xz.AdvanceFun(this.setForm, pagename).then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功');
              this.getSet();
              this.isBtnLoading = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      getSet() {
        let pagename = this.activeName == '1' ? 'GetFinancialDataSourcesSettings' : 'GetRefreshProfitSettings';
        xz.GetFinancialDataSourcesSettings(pagename).then(res => {
          if (res.status == 'ok') {
            this.setForm = res.data;
            this.setForm.type = number(res.data.type);
            this.setForm.day = number(res.data.day);
            this.setForm.isStart = number(res.data.isStart);
            this.time = res.data.hour + ':' + res.data.minute + ':' + res.data.second;
            this.GetCalcTransientCostsList();
          } else {}
        })
      },
      //手动计算
      handelCal() {
        if (this.handelMonth) {
          this.isBtnLoading = true;
          xz.CalcTransientCostsManually(this.handelMonth, '手工', 1).then(res => {
            if (res.status == 'ok') {
              this.$message.success('刷新成功')
              this.isBtnLoading = false;
            } else {
              this.$message.error(res.msg)
              this.isBtnLoading = false;
            }
          })
        } else {
          this.$message.warning('请选择月份')
        }
      },
      GetCalcTransientCostsList() {
        let data = {
          pageSize: 10,
          pageNum: 1,
          type: this.activeName == '1' ? 2 : 3
        }
        xz.GetCalcTransientCostsList(data).then(res => {
          if (res.status == 'ok') {
            this.calList = res.data.data
          } else {
            this.calList = [];
          }
        })
      },
      //计提
      ProfitProvision(id) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
            id
          }
          xz.AdvanceFun(data, 'ProfitProvision').then(res => {
            if (res.status == 'ok') {
              this.$message.success('计提成功');
              this.getList();
              this.loading = false;
            } else {
              this.$message.error(res.msg);
              this.getList();
              this.loading = false;
            }
          })
        }
      },
      mulProfitProvision() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach((element, index) => {
            arr.push(element.id)
            if (index == this.multipleSelection.length - 1) {
              this.ProfitProvision(arr.toString())
            }
          });
        }
      },
      //全部计提
      allProvision() {
        let data = JSON.parse(JSON.stringify(this.listQuery));
        data.ToProvision = 1;
        data.PageModel.Rows = 100000;
        data.PageModel.Page = 1;
        xz.AdvanceFun(data, 'GetAdvanceFinanCostsPageList').then(res => {
          if (res.status == 'ok') {
            this.$message.success('全部计提成功');
            this.getList();
            this.loading = false;
          } else {
            this.$message.error(res.msg);
            this.getList();
            this.loading = false;
          }
        })
      },
      changeType(val) {
        this.setForm.day = '';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }
</style>
<style>
  .page_finCost .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_finCost .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_finCost .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_finCost .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_finCost .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_finCost .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_finCost .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_finCost .el-checkbox__label {
    padding-left: 3px;
  }

  .page_finCost .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }
</style>